import * as tslib_1 from "tslib";
import { OnDestroy, } from '@angular/core';
import { AppStateFacade } from '@app-state';
import { PermissionService, RoleService, } from '@services';
import cloneDeep from 'lodash-es/cloneDeep';
import { BehaviorSubject, combineLatest, Subject, } from 'rxjs';
import { map, switchMap, takeUntil, } from 'rxjs/operators';
import { MODERN_FOLDERS_DEFAULT_ROLES, } from './ui-folders-default-roles.constants';
var ɵ0 = function (_a) {
    var name = _a.name;
    return "DisplayName eq '" + name + "'";
};
var ROLE_FILTER = MODERN_FOLDERS_DEFAULT_ROLES
    .map(ɵ0)
    .join(' or ');
var UiFoldersDefaultRolesComponent = /** @class */ (function () {
    function UiFoldersDefaultRolesComponent(_appState, _roleService, _permissionService) {
        var _this = this;
        this._appState = _appState;
        this._roleService = _roleService;
        this._permissionService = _permissionService;
        this.fetch$ = new BehaviorSubject(void 0);
        this.canViewRoles$ = this._appState.user.permissions.isGranted('Roles.View');
        this.roles$ = this.fetch$
            .pipe(switchMap(function (_) { return _this._roleService.get({
            top: MODERN_FOLDERS_DEFAULT_ROLES.length,
            expand: ['Permissions'],
            filter: "( " + ROLE_FILTER + " )",
        }); }), switchMap(function (results) { return _this._rolesWithFilteredPermissions$(results); }));
        this._defaultRoles$ = new BehaviorSubject(cloneDeep(MODERN_FOLDERS_DEFAULT_ROLES));
        this._destroyed$ = new Subject();
        this._filteredDefaultPermissions$ = combineLatest([
            this._permissionService.get()
                .pipe(map(function (_a) {
                var data = _a.data;
                return new Set(data.map(function (p) { return p.name; }));
            })),
            this._defaultRoles$,
        ]).pipe(map(function (_a) {
            var permissionsSet = _a[0], defaults = _a[1];
            return defaults
                .map(function (role) { return (tslib_1.__assign({}, role, { permissions: role.permissions
                    .filter(function (permission) { return permissionsSet.has(permission.name); }) })); });
        }));
        this._rolesWithFilteredPermissions$ = function (results) {
            return _this._filteredDefaultPermissions$
                .pipe(map(function (defaults) {
                return defaults.map(function (role) {
                    var existingRole = results.data.find(function (r) { return r.name === role.name; });
                    if (!existingRole) {
                        return role;
                    }
                    var missingPermissions = _this._findMissingPermissions(role, existingRole);
                    return tslib_1.__assign({}, role, (missingPermissions.length
                        ? {
                            status: 'incomplete',
                            missingPermissions: _this._permissionsToString(missingPermissions),
                        }
                        : { status: 'created' }));
                });
            }));
        };
        this._patchRoles = function (role) {
            return _this._defaultRoles$.next(_this._defaultRoles$.getValue()
                .map(function (r) { return r.name === role.name ? role : r; }));
        };
        this._permissionsToString = function (permissions) { return permissions.map(function (p) { return p.name; }).join(', '); };
        this._findMissingPermissions = function (role, existingRole) {
            return role.permissions
                .filter(function (perm) {
                return !existingRole.permissions
                    .find(function (p) { return p.name === perm.name && p.isGranted; });
            });
        };
    }
    UiFoldersDefaultRolesComponent.prototype.ngOnDestroy = function () {
        this._destroyed$.next();
    };
    UiFoldersDefaultRolesComponent.prototype.create = function (role) {
        var _this = this;
        role.status = 'pending';
        this._patchRoles(role);
        this._roleService.add({
            name: role.name,
            displayName: role.name,
            permissions: role.permissions,
        }).pipe(takeUntil(this._destroyed$)).subscribe(function (_) {
            role.status = 'created';
            _this._patchRoles(role);
        }, function () { return _this.fetch$.next(void 0); });
    };
    return UiFoldersDefaultRolesComponent;
}());
export { UiFoldersDefaultRolesComponent };
export { ɵ0 };
